const FJCanvasUtil = {
    clipToCanvas(ctx, clipPath, size) {
        const __convertToRect = (left = '0', right = '0', top = '0', bottom = '0', size) => {
            const { x, y, width, height } = size;
            const leftValue = left.indexOf('%') !== false ? (width * parseFloat(left)) / 100 : parseFloat(left);
            const rightValue = right.indexOf('%') !== false ? (width * parseFloat(right)) / 100 : parseFloat(right);
            const topValue = top.indexOf('%') !== false ? (height * parseFloat(top)) / 100 : parseFloat(top);
            const bottomValue =
                bottom.indexOf('%') !== false ? (height * parseFloat(bottom)) / 100 : parseFloat(bottom);

            return {
                x: leftValue + x,
                y: topValue + y,
                width: width - leftValue - rightValue,
                height: height - topValue - bottomValue,
            };
        };

        const __convertToPoints = (points, size) => {
            const { width, height } = size;
            const pointList = points.map(point => {
                const [x, y] = point.trimStart().split(' ');
                const isPercentageX = x.indexOf('%') !== false;
                const isPercentageY = y.indexOf('%') !== false;
                return {
                    x: isPercentageX ? (width * parseFloat(x)) / 100 : parseFloat(x),
                    y: isPercentageY ? (height * parseFloat(y)) / 100 : parseFloat(y),
                };
            });

            return pointList;
        };

        if (clipPath.indexOf('inset(') !== -1) {
            ctx.beginPath();
            const values = clipPath.replace('inset(', '').replace(')', '').split(' ');
            let top, bottom, left, right;
            if (values.length === 2) {
                top = bottom = values[0] || '0';
                left = right = values[1] || '0';
            } else {
                top = values[0] || '0';
                right = values[1] || '0';
                bottom = values[2] || '0';
                left = values[3] || '0';
            }

            const rect = __convertToRect(left, right, top, bottom, size);
            ctx.rect(rect.x, rect.y, rect.width, rect.height);
            ctx.clip();
        }

        if (clipPath.indexOf('polygon(') !== -1) {
            const points = clipPath.replace('polygon(', '').replace(')', '').split(',');
            ctx.beginPath();
            const convertPoints = __convertToPoints(points, size);

            convertPoints.forEach((point, index) => {
                if (index === 0) {
                    ctx.moveTo(point.x, point.y);
                }
                ctx.lineTo(point.x, point.y);
            });
            ctx.closePath();
            ctx.clip();
        }
    },
};

export default FJCanvasUtil;
